export function loginError (state, payload){
    state.error = true
    state.errorMessage = payload
    state.users = []
    state.isLogged = false
}
export function setJWT(state, payload){
    state.jwt = payload.data.jwt
    state.secret = payload.data.secret
    state.isLogged = true
    state.error= false
    state.msg = payload.msg
    state.rol_id = payload.data.user.rol_id
    state.id = payload.data.user.id // se guarda el id del login.
    state.vsap = payload.data.user.vsap
}
export function logout(state){
    state.jwt = ''
    state.secret = ''
    state.user = []
    state.isLogged = false
}

export function setJWTImage(state,payload){
    state.jwtImage = payload.data.token
}

export function loginErrorImage (state,payload){
    state.error = true,
    state.errorMessage = payload        
}